var _path, _path2, _path3, _path4, _path5, _circle, _path6, _ellipse, _path7, _ellipse2, _circle2, _ellipse3, _path8, _ellipse4, _ellipse5, _path9, _path10, _ellipse6, _circle3, _path11, _ellipse7, _ellipse8, _path12, _ellipse9, _circle4, _circle5, _circle6, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg403 = function Svg403(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 672.532 738.394"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M467 149.804c-46.62-7.44-99.71-11.41-155-11.41-50.6 0-99.35 3.32-142.98 9.58.01-.67.02-1.34.05-2.01a149 149 0 0 1 297.91 1.82c.01.68.02 1.35.02 2.02z",
    fill: "#6c63ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M337.55 1.341A149.047 149.047 0 0 0 168.62 144.57c-.031.67-.04 1.34-.05 2.01 12.961-1.86 26.384-3.454 40.164-4.784A149.022 149.022 0 0 1 337.55 1.34z",
    fill: "#fff",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M532.18 161.624a600.121 600.121 0 0 0-65.2-13.84 943.364 943.364 0 0 0-108.74-10.45 1133.608 1133.608 0 0 0-83.01-.34 973.29 973.29 0 0 0-106.16 8.97 624.292 624.292 0 0 0-77.25 15.66C32.61 177.994 0 199.934 0 223.394s32.61 45.4 91.82 61.77c41.64 11.52 92.98 19.37 148.92 22.97 23.09 1.5 46.96 2.26 71.26 2.26 24.38 0 48.33-.77 71.49-2.27 50.91-3.29 98.01-10.1 137.43-20 .21-.06.41-.11.62-.16 2.66-.66 5.28-1.35 7.87-2.04.93-.26 1.85-.51 2.77-.76a.978.978 0 0 1 .16-.05c.88-.24 1.75-.49 2.62-.73 1.74-.5 3.46-.99 5.15-1.5.08-.02.15-.04.22-.06 1.47-.44 2.91-.88 4.34-1.32 1.17-.37 2.33-.73 3.48-1.1q1.26-.405 2.49-.81c.6-.2 1.19-.39 1.77-.59.79-.26 1.58-.53 2.36-.8.33-.11.66-.22.98-.34.75-.25 1.48-.51 2.21-.77.79-.28 1.58-.57 2.36-.85.65-.23 1.3-.47 1.94-.71.54-.21 1.07-.41 1.61-.61 1.47-.55 2.91-1.12 4.33-1.68.71-.29 1.42-.57 2.12-.86.69-.28 1.39-.57 2.07-.86q1.68-.705 3.3-1.41c.52-.24 1.05-.47 1.56-.69.39-.18.77-.35 1.16-.53.28-.12.56-.25.83-.38 1.01-.46 2.01-.93 2.99-1.4q5.64-2.7 10.53-5.52c20.45-11.71 31.24-24.7 31.24-38.2 0-23.46-32.61-45.4-91.82-61.77zm-.54 121.62c-41.69 11.53-93.17 19.38-149.26 22.95-22.81 1.45-46.39 2.2-70.38 2.2-23.91 0-47.41-.74-70.15-2.19-56.18-3.56-107.74-11.41-149.49-22.96C34.09 267.124 2 245.874 2 223.394a24.118 24.118 0 0 1 .74-5.89c5.1-20.28 36.47-39.26 89.62-53.96a623.806 623.806 0 0 1 76.66-15.57 976.027 976.027 0 0 1 106.8-9q17.88-.585 36.18-.58c15.41 0 30.65.31 45.63.91a941.367 941.367 0 0 1 109.37 10.5 598.858 598.858 0 0 1 64.64 13.74c53.14 14.7 84.5 33.67 89.61 53.94a23.822 23.822 0 0 1 .75 5.91c0 22.48-32.09 43.73-90.36 59.85z",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M623.43 224.304c0 13.36-11.01 26-30.67 37.29-3.27 1.88-6.79 3.72-10.53 5.52-.98.47-1.98.94-2.99 1.4-.27.13-.55.26-.83.38-.39.18-.77.35-1.16.53-.51.22-1.04.45-1.56.69q-1.62.705-3.3 1.41c-.68.29-1.38.58-2.07.86-.7.29-1.41.57-2.12.86-1.42.56-2.86 1.13-4.33 1.68-.54.2-1.07.4-1.61.61-.64.24-1.29.48-1.94.71-.78.28-1.57.57-2.36.85-.73.26-1.46.52-2.21.77-.32.12-.65.23-.98.34-.78.27-1.57.54-2.36.8-.58.2-1.17.39-1.77.59q-1.23.405-2.49.81c-1.15.37-2.31.73-3.48 1.1-1.43.44-2.87.88-4.34 1.32-.07.02-.14.04-.22.06-1.69.51-3.41 1-5.15 1.5-.87.24-1.74.49-2.62.73a.978.978 0 0 0-.16.05c-.92.25-1.84.5-2.77.76-2.58.68-5.21 1.37-7.87 2.04-.21.05-.41.1-.62.16-38.35 9.58-85.4 16.56-137.47 19.93-22.81 1.47-46.59 2.25-71.02 2.25-24.65 0-48.63-.79-71.62-2.29-137.24-8.95-239.38-43.03-239.38-83.71a25.072 25.072 0 0 1 1.12-7.3c.06.17.12.33.19.5 14.27 37.48 115.54 67.77 246.94 75.16 20.13 1.14 40.98 1.73 62.32 1.73 21.43 0 42.36-.6 62.57-1.74 131.29-7.42 232.46-37.72 246.68-75.17q.36-.9.63-1.8a25.305 25.305 0 0 1 1.55 8.62zM91.67 213.54c-16.643 0-34.331-3.58-34.331-10.217s17.688-10.217 34.33-10.217S126 196.687 126 203.323s-17.688 10.217-34.33 10.217zm0-18.434c-19.054 0-32.331 4.331-32.331 8.217s13.277 8.217 32.33 8.217S124 207.21 124 203.323s-13.278-8.217-32.33-8.217z",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.67 260.54c-16.643 0-34.331-3.58-34.331-10.217s17.688-10.217 34.33-10.217c16.643 0 34.331 3.581 34.331 10.217s-17.688 10.217-34.33 10.217zm0-18.434c-19.054 0-32.331 4.331-32.331 8.217s13.277 8.217 32.33 8.217S195 254.21 195 250.323s-13.278-8.217-32.33-8.217zm369-28.566c-16.643 0-34.331-3.58-34.331-10.217s17.688-10.217 34.33-10.217c16.643 0 34.331 3.581 34.331 10.217s-17.688 10.217-34.33 10.217zm0-18.434c-19.054 0-32.331 4.331-32.331 8.217s13.277 8.217 32.33 8.217S564 207.21 564 203.323s-13.278-8.217-32.33-8.217zm-71 65.434c-16.643 0-34.331-3.58-34.331-10.217s17.688-10.217 34.33-10.217c16.643 0 34.331 3.581 34.331 10.217s-17.688 10.217-34.33 10.217zm0-18.434c-19.054 0-32.331 4.331-32.331 8.217s13.277 8.217 32.33 8.217S493 254.21 493 250.323s-13.278-8.217-32.33-8.217zm-149 40.434c-16.643 0-34.331-3.58-34.331-10.217s17.688-10.217 34.33-10.217c16.643 0 34.331 3.581 34.331 10.217s-17.688 10.217-34.33 10.217zm0-18.434c-19.054 0-32.331 4.331-32.331 8.217s13.277 8.217 32.33 8.217S344 276.21 344 272.323s-13.278-8.217-32.33-8.217z",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 336.978,
    cy: 450.704,
    r: 42.012,
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m300.556 488.546 20.447-10.24 5.715 11.412-20.448 10.24z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 563.82,
    cy: 573.748,
    rx: 3.989,
    ry: 10.636,
    transform: "rotate(-56.601 356.921 778.245)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m347.239 489.72 5.715-11.413 20.447 10.24-5.715 11.412z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 637.604,
    cy: 573.748,
    rx: 10.636,
    ry: 3.989,
    transform: "rotate(-33.399 371.066 972.9)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 334.037,
    cy: 440.428,
    r: 14.359,
    fill: "#fff"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 597.87,
    cy: 515.084,
    rx: 4.766,
    ry: 4.8,
    transform: "rotate(-45 368.465 793.038)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M370.12 405c.632-15.554-12.773-28.728-29.941-29.426s-31.597 11.346-32.229 26.9 11.302 19.087 28.47 19.785 33.068-1.706 33.7-17.26z",
    fill: "#6c63ff"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 644.388,
    cy: 537.568,
    rx: 6.594,
    ry: 21.006,
    transform: "rotate(-40.645 403.434 853.218)",
    fill: "#2f2e41"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 557.154,
    cy: 537.568,
    rx: 21.006,
    ry: 6.594,
    transform: "rotate(-49.355 337.356 784.164)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M348.517 467.26a9.572 9.572 0 0 1-18.836 3.43l-.003-.019c-.942-5.202 3.08-7.043 8.282-7.985s9.615-.627 10.557 4.575z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M266 495.394a2 2 0 0 1-2-2v-118a2 2 0 0 1 4 0v118a2 2 0 0 1-2 2zm-30 106a2 2 0 0 1-2-2v-86a2 2 0 1 1 4 0v86a2 2 0 0 1-2 2zm77-71a2 2 0 0 1-2-2v-118a2 2 0 1 1 4 0v118a2 2 0 0 1-2 2zm-29 85a2 2 0 0 1-2-2v-48a2 2 0 1 1 4 0v48a2 2 0 0 1-2 2zm41-246a2 2 0 0 1-2-2v-48a2 2 0 0 1 4 0v48a2 2 0 0 1-2 2zm-100 21a2 2 0 0 1-2-2v-48a2 2 0 0 1 4 0v48a2 2 0 0 1-2 2zm174 5a2 2 0 0 1-2-2v-48a2 2 0 1 1 4 0v48a2 2 0 0 1-2 2zm-4 150a2 2 0 0 1-2-2v-58a2 2 0 1 1 4 0v58a2 2 0 0 1-2 2zm-40 51a2 2 0 0 1-2-2v-86a2 2 0 1 1 4 0v86a2 2 0 0 1-2 2zm8-147a2 2 0 0 1-2-2v-118a2 2 0 1 1 4 0v118a2 2 0 0 1-2 2z",
    fill: "#ccc"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 858.104,
    cy: 764.783,
    rx: 6.76,
    ry: 21.534,
    transform: "rotate(-39.938 615.048 1087.291)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.297,
    cy: 757.305,
    r: 43.067,
    transform: "rotate(-71.565 624.375 899.86)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M553.707 710.302h13.084v23.442h-13.084zm-26.167 0h13.084v23.442H527.54z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 555.888,
    cy: 734.016,
    rx: 10.903,
    ry: 4.089,
    fill: "#2f2e41"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 529.72,
    cy: 733.471,
    rx: 10.903,
    ry: 4.089,
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M535.04 622.366c3.845-15.487 20.82-24.601 37.914-20.357s27.834 20.24 23.989 35.728-16.604 15.537-33.698 11.292-32.051-11.176-28.206-26.663z",
    fill: "#ccc"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 763.788,
    cy: 737.322,
    rx: 6.76,
    ry: 21.534,
    transform: "rotate(-64.626 568.044 905.41)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 542.124,
    cy: 667.415,
    r: 14.359,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 536.222,
    cy: 662.268,
    r: 4.786,
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 542,
    cy: 697.394,
    r: 6,
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M671.532 738.394h-236a1 1 0 0 1 0-2h236a1 1 0 0 1 0 2z",
    fill: "#3f3d56"
  })));
};
export default Svg403;